import React, { Fragment } from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { FormControl, Dialog, DialogContent, DialogTitle, TextField, Button } from '@material-ui/core';

import DriverTruckEdit from '../../../models/DriverTruckEdit';

import drvTrkUpdateStyles from './drvTrkUpdate.module.css';

const TEXT_FIELD_PADDINGS: string = '12px 3px 13px 10px';
const styles = (theme: Theme) =>

  createStyles({
    textField45: {
      width: '45%'
    },
    textField100: {
      width: '100%'
    },
    textField: {
      marginTop: '38px',
      '& input': {
        color: 'var(--primaryblue)',
        fontSize: '14px'
      },
      '& fieldset': {
        borderRadius: '10px'
      },
    },
    cancelBtn: {
      marginRight: '3%'
    }
  });

interface DriverInfoAndTruckCoUpdateModalProps { 
  classes: any;
  modalOpen: boolean;
  handleClose: () => void;
  handleChange: (fieldName: string, event: any) => void;
  handleUpdate: () => void;
  selectedDrvTrkData: DriverTruckEdit;
};

const driverInfoAndTruckCoUpdateModal = (props: DriverInfoAndTruckCoUpdateModalProps) => {

  const { classes } = props;
    
  return (
    <Dialog
      open={ props.modalOpen }
      onClose={ () => props.handleClose() }
      aria-labelledby="form-dialog-title"
      maxWidth={ 'xl' }
      disableBackdropClick={ true }
      disableEscapeKeyDown= { true }
    >
      <DialogTitle id="form-dialog-title" >
        <div className={ drvTrkUpdateStyles.dialogTitle }>
          <span className={ drvTrkUpdateStyles.title }>Edit Trucking Company and Driver Info</span>
          <IconButton aria-label="Close" className={ drvTrkUpdateStyles.close } onClick={ props.handleClose }>
            <CloseIcon color='primary' />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className={ drvTrkUpdateStyles.dialogContent }>

        <FormControl>
          <div className={ drvTrkUpdateStyles.inputsWrapper }>
            <div className={ drvTrkUpdateStyles.firstInputsWrapper }>
              <TextField
                label="Trucking Company Name"
                className={ [classes.textField45, classes.textField].join(' ') }
                variant="outlined"
                value={ props.selectedDrvTrkData.delivery_company_name_new }
                onChange={ (event) => props.handleChange('delivery_company_name_new', event) }
                inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                label="Truck Plate Number"
                className={ [classes.textField45, classes.textField].join(' ')}
                variant="outlined"
                value={ props.selectedDrvTrkData.driver_vehichle_registration }
                onChange={ (event) => props.handleChange('driver_vehichle_registration', event) }
                inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
                InputLabelProps={{ shrink: true }}
              />
            </div>

            <div className={ drvTrkUpdateStyles.secondInputsWrapper }>
              <TextField
                label="Driver's Name"
                className={ [classes.textField100, classes.textField].join(' ') }
                variant="outlined"
                value={ props.selectedDrvTrkData.driver_name }
                onChange={ (event) => props.handleChange('driver_name', event) }
                inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
                InputLabelProps={{ shrink: true }}
              />
            </div>

            <div className={ drvTrkUpdateStyles.firstInputsWrapper }>
              <TextField
                label="Driver's ID"
                className={ [classes.textField45, classes.textField].join(' ') }
                variant="outlined"
                value={ props.selectedDrvTrkData.driver_id }
                onChange={ (event) => props.handleChange('driver_id', event) }
                inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
                InputLabelProps={{ shrink: true }}
              />
              
              <TextField
                label="Driver's ID Type"
                className={ [classes.textField45, classes.textField].join(' ') }
                variant="outlined"
                value={ props.selectedDrvTrkData.driver_id_type }
                onChange={ (event) => props.handleChange('driver_id_type', event) }
                inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
                InputLabelProps={{ shrink: true }}
              />
            </div>
          </div>
        </FormControl>
        
        <div className={ drvTrkUpdateStyles.buttonsWrapper }>
          <Button
            color="default"
            className={ classes.cancelBtn }
            variant="contained"
            onClick={ props.handleClose }
          >Cancel</Button>
          <Button
            color="primary"
            variant="contained"
            onClick={ props.handleUpdate }
          >Update</Button>
        </div>

      </DialogContent>
    </Dialog>
  )
};

export default withStyles(styles)(driverInfoAndTruckCoUpdateModal);
